export enum FieldKey {
  LegalName = "legalName",
  DateOfBirth = "dateOfBirth",
  DateOfOrganization = "dateOfOrganization",
  TaxId = "taxId",
  TaxIdType = "taxIdType",
  AccountType = "accountType",
  Address = "address",
  RiskRating = "riskRating",
  AmlQuestion = "amlQuestion",
  Document = "document",
  Owners = "owners",
  Controllers = "controllers",
}

export const EM_DASH = "--";
